import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-check-button',
  templateUrl: './check-button.component.html',
  styleUrls: ['./check-button.component.scss'],
  standalone: false,
})
export class CheckButtonComponent {
  @Input() public checked = false;
  @Input() public title = '';
  @Input() public info = '';
  @Input() public reverse = false;
  @Input() public smallFont = false;
}
